import {inject, Injectable} from '@angular/core';
import {Actions, concatLatestFrom, createEffect, ofType} from '@ngrx/effects';
import {Store} from '@ngrx/store';
import {filter, map} from 'rxjs';
import {RouterActions} from '@adnova/jf-ng-components';
import {DatevWizardCaseSelectionActions} from './datev-wizard-case-selection.actions';
import {DatevWizardGetFirmaSelectors} from '../../datev-wizard-get-firma/+store/datev-wizard-get-firma.selectors';
import {DatevWizardCaseSelectionSelectors} from './datev-wizard-case-selection.selectors';
import {Router} from '@angular/router';

/**
 * DatevWizardCaseSelectionEffects
 *
 * Effects für die Fallauswahl im DATEV-Wizard.
 * Triggert die Navigation zu client-id nach der Fallauswahl.
 */
@Injectable()
export class DatevWizardCaseSelectionEffects {
  private readonly _actions$ = inject(Actions);
  private readonly _store = inject(Store);
  private readonly _router = inject(Router);

  /**
   * Nach der Fallauswahl automatisch zu client-id navigieren.
   * Navigiert NUR wenn der User auf der case-selection Seite ist.
   * Verhindert ungewollte Navigation wenn selectCase von anderen Komponenten dispatcht wird.
   *
   * @trigger selectCase
   * @dispatch goToClientId
   */
  readonly selectCase$ = createEffect(() =>
    this._actions$.pipe(
      ofType(DatevWizardCaseSelectionActions.selectCase),
      filter(() => {
        const currentUrl = this._router.url;
        return currentUrl.includes('/wizard/case-selection/');
      }),
      map(() => DatevWizardCaseSelectionActions.goToClientId())
    )
  );

  /**
   * Navigiert zur client-id Seite mit der Firmen-ID und dem ausgewählten Fall.
   *
   * @trigger goToClientId
   * @dispatch RouterActions.navigateByUrl
   */
  readonly goToClientId$ = createEffect(() =>
    this._actions$.pipe(
      ofType(DatevWizardCaseSelectionActions.goToClientId),
      concatLatestFrom(() => [
        this._store.select(DatevWizardGetFirmaSelectors.firmenId),
        this._store.select(DatevWizardCaseSelectionSelectors.selectedCase),
      ]),
      map(([, firmenId, selectedCase]) => {
        const fall = selectedCase; // 'fall1' oder 'fall2'
        const url = `/datev/income-tax-documents/wizard/client-id/inhaber/${firmenId}/fall/${fall}`;
        return RouterActions.navigateByUrl({ url });
      })
    )
  );
}
